<script setup lang="ts">
import { useUserStore } from '@/stores/modules/user'
import FooterBar from '@/components/footer-bar/FooterBar.vue'
import { treasuryInfoList, type TreasuryItemType } from './data'
import { ref } from 'vue'
import { formatNumberWithCommas } from '@/utils'

const userStore = useUserStore()
const info = ref<TreasuryItemType>()
</script>

<template>
  <div class="treasury-page page">
    <h2>持有道具</h2>
    <div class="border-wrap treasury-list">
      <el-popover placement="bottom" :width="300" trigger="click" :teleported="false" v-for="item of treasuryInfoList">
        <template #reference>
          <el-button type="primary" plain @click="info = item" v-show="item.show ? item.show(userStore.consumables[item.key]) : true">
            {{ item.name }}（{{ formatNumberWithCommas(userStore.consumables[item.key]) }}）
          </el-button>
        </template>
        <h4>{{ info?.name }}</h4>
        <p>用途：{{ info?.desc }}</p>
        <p>持有数量：{{ info?.key && userStore.consumables[info.key] }}</p>
      </el-popover>
    </div>
    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.treasury-page {
  padding-top: 0;
  display: flex;
  flex-flow: column nowrap;
  overflow: hidden;
  .treasury-list {
    display: flex;
    flex-flow: row wrap;
    padding: 10px;
    justify-content: space-between;
    overflow: auto;
    button {
      width: calc(50% - 5px);
      margin-left: 0;
      margin-bottom: 10px;
      &:nth-last-child(-n + 2) {
        margin-bottom: 0;
      }
    }
  }
}
</style>
